import React from 'react';

import { toAbsoluteUrl } from '@mirai-kids-monte/core/src/constants/SiteUrl';
import Head from 'next/head';
import { BUSINESS_NAME } from '../../constants/BusinessSchema';

type Props = {
  title: string;
  description: string;
  twitterCardType?: 'summary' | 'summary_large_image' | 'app' | 'player';
  ogpType?: 'article' | 'profile' | 'book' | 'website';
  thumbnailImageUrl?: string;
  canonicalUrl?: string;
  robotsContent?: string;
  children?: React.ReactNode;
};

const CustomHead: React.FC<Props> = ({
  title,
  description,
  twitterCardType = 'summary',
  ogpType = 'article',
  thumbnailImageUrl,
  canonicalUrl,
  robotsContent,
  children,
}) => {
  const absoluteThumbnailUrl = thumbnailImageUrl ? toAbsoluteUrl(thumbnailImageUrl) : undefined;
  const absoluteCanonicalUrl = canonicalUrl ? toAbsoluteUrl(canonicalUrl) : undefined;
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      {robotsContent ? <meta name="robots" content={robotsContent} /> : null}
      <meta property="og:type" content={ogpType} />
      <meta property="og:site_name" content={BUSINESS_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {absoluteThumbnailUrl ? <meta property="og:image" content={absoluteThumbnailUrl} /> : null}
      {absoluteCanonicalUrl ? <meta property="og:url" content={absoluteCanonicalUrl} /> : null}
      {absoluteCanonicalUrl ? <link rel="canonical" href={absoluteCanonicalUrl} /> : null}
      <meta name="twitter:creator" content="みらいキッズモンテプリスクール" />
      <meta name="twitter:card" content={twitterCardType} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {absoluteThumbnailUrl ? <meta name="twitter:image" content={absoluteThumbnailUrl} /> : null}
      {children}
    </Head>
  );
};

export default CustomHead;
